import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import NodeAttachmentList from "./NodeAttachmentList";
import IconButton from "~app/components/IconButton";
import NodeImageUpload from "./NodeImageUpload";
import { removeNode, updateNode } from "~app/actions/nodeList";
import { withT } from "~app/BundleProvider";

class NodeContent extends Component {
  static propTypes = {
    node: PropTypes.object.isRequired,
    removeNode: PropTypes.func.isRequired,
    updateNode: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      description: this.props.node.description,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.node.description !== this.state.description)
      this.setState({ description: nextProps.node.description });
  }

  handleChangeDescription = event =>
    this.setState({ description: event.target.value });

  updateDescription = event => {
    if (this.state.description !== this.props.node.description) {
      this.props.updateNode(this.props.node.id, {
        description: this.state.description,
      });
    }
  };

  render() {
    const { t } = this.props;
    return (
      <div className="NodeContent">
        <div className="NodeImageList">
          <NodeImageUpload id={this.props.node.id} index={0} />
          <NodeImageUpload id={this.props.node.id} index={1} />
        </div>
        <div className="NodeMainContent">
          <div className="NodeDescription">
            <textarea
              placeholder={t("add-description")}
              aria-label={t("add-description-input")}
              value={this.state.description}
              onChange={this.handleChangeDescription}
              onBlur={this.updateDescription}
            />
          </div>
          <NodeAttachmentList id={this.props.node.id} />
        </div>
        <div className="NodeDelete">
          <IconButton
            styleName="NodeDelete__icon"
            ariaLabel={t("delete-node")}
            onClick={() => this.props.removeNode(this.props.node.id)}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  removeNode,
  updateNode,
};

export { NodeContent };
export default withT(connect(null, mapDispatchToProps)(NodeContent));



// WEBPACK FOOTER //
// ./src/pages/Main/NodeList/NodeContent.js